import { sensorsAuthScripts, sensorsTrack } from "~/utils/sensors";


sensorsAuthScripts();

//@ts-ignore
export default ({ app, store }, inject) => {

  inject('sensorsTrack', sensorsTrack)
}